import { useEffect, useState } from 'react';
import api from '../../lib/api';
import { ACTION_LABELS, formatWhen } from './dutiShared';
import { Loader2 } from 'lucide-react';

const EVENT_STYLES = {
  proposed: 'bg-sky-500', approved: 'bg-emerald-500', rejected: 'bg-rose-500',
  expired: 'bg-zinc-400', blocked: 'bg-amber-500', failed: 'bg-rose-700', settings_changed: 'bg-violet-500',
  alert_sent: 'bg-teal-500', alert_skipped: 'bg-orange-400',
};

export const ActivityLog = () => {
  const [events, setEvents] = useState(null);
  useEffect(() => {
    api.get('/duti/activity').then(({ data }) => setEvents(data.events)).catch(() => setEvents([]));
  }, []);

  if (events === null) return <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />;
  if (!events.length) return <p className="text-sm text-muted-foreground" data-testid="duti-activity-empty">No Duti AI activity yet.</p>;

  return (
    <ol className="relative border-l ml-2 space-y-5" data-testid="duti-activity-log">
      {events.map((e) => (
        <li key={e.event_id} className="pl-6 relative" data-testid={`duti-activity-${e.event_id}`}>
          <span className={`absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full ${EVENT_STYLES[e.event] || 'bg-zinc-400'}`} />
          <p className="text-sm">
            <span className="font-medium capitalize">{e.event.replaceAll('_', ' ')}</span>
            {e.action_type && <span className="text-muted-foreground"> · {ACTION_LABELS[e.action_type]}</span>}
          </p>
          <p className="text-sm mt-0.5">{e.summary}</p>
          <p className="text-xs text-muted-foreground mt-0.5">
            {e.actor_name} · {formatWhen(e.created_at)}{e.note ? ` — “${e.note}”` : ''}
          </p>
        </li>
      ))}
    </ol>
  );
};
